<template>
  <div>
    <template v-if="showDetails">
      <dl class="mx-auto border-t grid gap-px grid-cols-2 py-2" :class="[$theme.cardBorderColor]">
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 p-1">
          <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
            {{ $t('started') }}
          </dt>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dd class="w-full text-sm font-semibold tracking-tight" :class="[$theme.baseTextColor]">
            {{ details.started }}
          </dd>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
            {{ $t('term_apply') }}
          </dt>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dd class="w-full text-sm font-semibold tracking-tight" :class="[$theme.baseTextColor]">
            {{ details.term_apply }}
          </dd>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
            {{ $t('contact_filled') }}
          </dt>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dd class="w-full text-sm font-semibold tracking-tight" :class="[$theme.baseTextColor]">
            {{ details.contact_filled }}
          </dd>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
            {{ $t('tariff_payed') }}
          </dt>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dd class="w-full text-sm font-semibold tracking-tight" :class="[$theme.baseTextColor]">
            {{ details.tariff_payed }}
          </dd>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
            {{ $t('completed') }}
          </dt>
        </div>
        <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-1">
          <dd class="w-full text-sm font-semibold tracking-tight" :class="[$theme.baseTextColor]">
            {{ details.trade_started }}
          </dd>
        </div>
      </dl>
    </template>
    <button @click="onShowDetail" class="w-full border-t text-sm py-1 flex items-center justify-center" :class="[$theme.cardBorderColor, $theme.cardLabelTextColor]">
      <template v-if="showDetails === false">
        <ChevronDownIcon class="w-4 mr-2" />
        {{ $t('detail') }}
      </template>
      <template v-if="showDetails === true">
        <ChevronUpIcon class="w-4 mr-2" />
        {{ $t('collapse') }}
      </template>
    </button>
  </div>
</template>
<script>
import {ChevronDownIcon, ChevronUpIcon} from "@heroicons/vue/24/outline";

export default {
  components: {ChevronDownIcon, ChevronUpIcon},
  props: [
    'details'
  ],

  methods: {
    onShowDetail() {
      this.showDetails = !this.showDetails;
    }
  },

  data() {
    return {
      showDetails: false,
    }
  }
};
</script>